import { createWithEqualityFn } from "zustand/traditional";
import { AuthConfigStore } from "./types";

const initialState = {
  enableWafCode: false,
  wafSiteKey: "",
  formKey: "",
  isLoaded: false,
  disablePhone: false,
  enableImageCode: false,
};

/**
 * AuthConfig Store
 * 用于管理认证配置状态
 */
export const useAuthConfigStore = createWithEqualityFn<AuthConfigStore>(
  set => ({
    ...initialState,

    setAuthConfig: config => {
      set({
        ...config,
        isLoaded: true,
      });
    },

    reset: () => {
      set(initialState);
    },
  })
);

export * from "./types";
